import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MessageTwoToneSvg from "@ant-design/icons-svg/es/asn/MessageTwoTone";
import AntdIcon from "../components/AntdIcon";
var MessageTwoTone = function MessageTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MessageTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MessageTwoTone.displayName = 'MessageTwoTone';
}
export default /*#__PURE__*/React.forwardRef(MessageTwoTone);